import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/Navbar.css";
import donwloadVideosLogo from "../assets/images/donwload-video-white.png";


const Navbar = () => {


  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left Side - Logo / Home Link */}
        <div className="logo">          
          <Link to="/">  
            <img src={donwloadVideosLogo} alt="download-videos" style={{ width: "10x" }} /> 

          </Link>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
